'use es6';

import { createContext, useRef, useState } from 'react';
import { getLocaleFromUrl, loadI18n } from '../../../utils/I18n';
import getLang from 'I18n/utils/getLang';
import { jsx as _jsx } from "react/jsx-runtime";
export const LocaleContext = /*#__PURE__*/createContext({
  selectedLocale: '',
  // the locale selected in the LanguageSelect
  locale: '',
  // defaults to selectedLocale, falls back to browser lang
  setLocale: () => {}
});
const LocaleProvider = ({
  children
}) => {
  const [selectedLocale, setSelectedLocale] = useState(getLocaleFromUrl());
  const initialLanguageRef = useRef(getLang());
  const setLocale = selected => {
    const locale = selected || initialLanguageRef.current;
    loadI18n(locale).then(() => setSelectedLocale(selected)).catch(() => {
      //Todo: Send this to an error log https://git.hubteam.com/HubSpot/subscriptions/issues/2670
    });
  };
  return /*#__PURE__*/_jsx(LocaleContext.Provider, {
    value: {
      selectedLocale,
      setLocale,
      locale: selectedLocale || getLang()
    },
    children: children
  });
};
export default LocaleProvider;